<style scoped>
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
</style>

<template>
  <div>
    <div
      class="text-h4 font-weight-black primary--text text-spacing"
      color="blue"
    >
      ลูกค้าหมดสัญญา
    </div>
    <v-divider class="my-2"></v-divider>
    <filterCustomer
      :fromPage="'ex_contract'"
      v-on:returnExContract="clickReturn"
      :isfromNew="isfromNew"
    />
    <v-layout class="mb-n3" justify-end>
      <v-btn
        color="white excel-border"
        elevation="0"
        light
        @click="export_xls()"
      >
        <v-icon left>mdi-printer</v-icon>ดาวน์โหลด excel
      </v-btn>
    </v-layout>
    <v-layout v-resize="onResize" column class="pt-5">
      <v-data-table :headers="headers" :items="getIndex" :search="search">
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
        <template v-slot:item.CONTRACT_START_DATE="{ item }">{{
          item.CONTRACT_START_DATE | formatDate
        }}</template>
        <template v-slot:item.CONTRACT_END_DATE="{ item }">{{
          item.CONTRACT_END_DATE | formatDate
        }}</template>
        <template v-slot:item.RENEW_CONTRACT="{ item }"
          ><v-btn depressed color="primary" @click="renewContract(item)">
            ต่อสัญญา
          </v-btn></template
        >
      </v-data-table>
    </v-layout>
  </div>
</template>

<script>
import filterCustomer from "../components/filterCustomer";
import moment from "moment";
import XLSX from "xlsx";
import TableMenu from "../components/TableMenu";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "ExContract",
  components: {
    filterCustomer,
    TableMenu,
  },
  data: () => ({
    isfromNew: false,
    fav: true,
    menu: false,
    message: false,
    hints: true,
    pagination: {
      sortBy: "name",
    },
    selected: [],
    search: "",
    isMobile: false,
    headers: [
      {
        text: "ที่",
        align: "start",
        sortable: true,
        value: "id",
      },
      { text: "วันที่ทำสัญญา", value: "CONTRACT_START_DATE", align: "center" },
      {
        text: "เลขที่สัญญา",
        align: "start",
        sortable: true,
        value: "CONTRACT_ID",
      },
      { text: "ชื่อสถานบริการ", value: "CUSTOMER_NAME" },
      { text: "ประเภท", value: "CONTRACT_CATEGORY" },
      { text: "กลุ่มลูกค้า", value: "CUSTOMER_GROUP" },
      { text: "ระยะเวลา(ปี)", value: "CONTRACT_PERIOD", align: "center" },
      // { text: "ระยะเวลา (วัน)", value: "CONTRACT_START_DATE" },
      { text: "วันที่หมดสัญญา", value: "CONTRACT_END_DATE", align: "center" },
      { text: "ต่อสัญญา", value: "RENEW_CONTRACT", align: "center" },
      // { text: "แก้ไข", value: "edit", align: "center" },
      // { text: "ลบ", value: "delete", align: "center" },
    ],
    contractList: [],
  }),
  computed: {
    ...mapGetters({
      GET_CONTRACT_ENDDATE: "Contract/GET_CONTRACT_ENDDATE",
    }),
    // count index in table and chang date format
    getIndex() {
      return this.contractList.map((item, index) => ({
        ...item,
        id: index + 1,
        // create_date: moment(CREATE_DATE)
        //   .add(543, "years")
        //   .format("DD/MM/YYYY hh:mm:ss", true),
      }));
    },
  },
  created() {
    this.listAllContract();
    //this.list_c_period();
  },
  filters: {
    delimeter(data) {
      let y = parseFloat(data).toFixed(2);
      let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return x;
    },
    formatDate(data) {
      return moment(data).locale("th").add(543, "Y").format("LL");
    },
  },
  methods: {
    ...mapMutations({
      LOADER: "Drawer/SET_LOADER",
      C_EDIT: "Contract/SET_IS_EDIT",
      C_SET: "Contract/SET_ELEMENT",
      C_SET_PRODUCT: "Contract/SET_PRODUCT_LIST",
      C_SET_ALL: "Contract/SET_ALL_ELEMENT",
      C_MERGE: "Contract/MERGE_ALL_ELEMENT",
      SET_STEP: "Drawer/SET_STEP",
      SET_RENEW: "Contract/SET_IS_RENEW",
    }),
    export_xls() {
      // this.LOADER(true);
      let data = this.getIndex;
      let xls_json = [];
      if (data.length > 0) {
        var i = 1;
        data.forEach((element) => {
          xls_json.push({
            ลำดับ: i,
            วันที่ทำสัญญา: moment(element.CONTRACT_START_DATE).format(
              "DD-MM-YYYY"
            ),
            เลขที่สัญญา: element.CONTRACT_ID,
            สถานบริการ: element.CUSTOMER_NAME,
            ประเภท: element.CONTRACT_CATEGORY,
            กลุ่มลูกค้า: element.CUSTOMER_GROUP,
            "ระยะเวลา(ปี)": element.CONTRACT_PERIOD,
            วันที่หมดสัญญา: moment(element.CONTRACT_END_DATE).format(
              "DD-MM-YYYY"
            ),
          });
          i++;
        });
        const dataWS = XLSX.utils.json_to_sheet(xls_json);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, dataWS);
        XLSX.writeFile(wb, `รายงานสัญญา_${moment().format("DD-MM-YYYY")}.xlsx`);
        // this.LOADER(false);
      } else {
        // this.LOADER(false);
        this.$swal({
          title: "ไม่พบข้อมูล",
          icon: "warning",
          text: `กรุณาเลือกเดือนที่มีข้อมูลรายงาน`,
          timer: 2000,
        });
      }
    },
    create_form() {
      this.$router.push({ path: "/form" });
    },

    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.desserts.slice();
    },
    changeSort(column) {
      // console.log(column);
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    clickReturn(val) {
      this.contractList = val;
    },
    listAllContract() {
      this.$token_api
        .post("/list-expire-contract")
        .then((res) => {
          this.contractList = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async renewContract(tbl_data) {
      // this.LOADER(true);
      let response = await this.$token_api
        .post("/list-contract-by-id", {
          CONTRACT_ID: tbl_data.CONTRACT_ID,
        })
        .catch((err) => {
          // this.LOADER(false);
        });

      let data = response.data.data;
      // console.log(data);
      if (data.length > 0) {
        const prod_detail = await new Response(data[0].PRODUCT_LIST).json();
        // this.SET_STEP(3);
        this.SET_RENEW(true);
        this.C_SET({ key: "IS_CONTRACT", value: false });

        let x = moment(new Date(data[0].CONTRACT_END_DATE)).add(1,'d').format()
      
        
        this.$store.commit("Drawer/SET_STEP", 3);
        this.C_MERGE(data[0]);
        this.C_SET_PRODUCT(prod_detail);
        this.C_EDIT(true);
        this.C_SET({
          key: "CONTRACT_START_DATE",
          value: x,
        });
        this.$router.push({ path: "/form" });
        // this.LOADER(false);
      } else {
        // this.LOADER(false);
      }
    },
  },
};
</script>
